export default "__VITE_ASSET__DfH8WI$a__"